// extracted by mini-css-extract-plugin
export default {"title":"cyOF6nmeDDrJEInDednO"};